import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';

export const usePizzas = () => {
  return useQuery({
    queryKey: ["public-products"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("products")
        .select("id, name_product, description, price_month, category, discount, stock, product_images (image_url, position)")
        .order("id", { ascending: false });

      if (error) throw error;
      return data;
    },
  });
};